import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  isOutletDocument?: boolean
  id?: string;
  _file?: File;
  key?: string;
  btnId?: string;
}

const WebService = {
  // postAPI(props: PropData) {
  //   return new Promise((resolve, reject) => {
  //     var bodyFormData = new FormData();

  //     const body = props.body;
  //     if (props.isFormData && Array.isArray(body)) {
  //       body.forEach((el: any, i: number) => {
  //         if (props.isOutletDocument) {
  //           bodyFormData.append(`documents[${i}]title`, el.title || '');
  //           bodyFormData.append(`documents[${i}]code`, el.code || '');
  //           bodyFormData.append(`documents[${i}]having_document_no`, String(el.having_document_no));
  //           bodyFormData.append(`documents[${i}]document_number`, el.document_number || '');


  //           if (el.file instanceof File) {
  //             bodyFormData.append(`documents[${i}]file`, el.file);
  //           }
  //         } else {
  //           bodyFormData.append(`${props?.key}[${i}]`, el);
  //         }
  //       });
  //     } else {
  //       for (let key in props.body) {
  //         const d = props.body[key];
  //         bodyFormData.append(key, d);
  //       }
  //     }

  //     const headers = {
  //       Authorization: "Bearer " + localStorage.getItem("access_token"),
  //       appid: localStorage.getItem("app_id"),
  //     };
  //     WebService.addLoader(props.btnId);
  //     axios.post(
  //       `${BASE_URL}${props.action}`,
  //       props.isFormData ? bodyFormData : props.body,
  //       { headers }
  //     )
  //       .then((response) => {
  //         resolve(response.data);
  //         toast.success(response?.data?.message);
  //         WebService.removeLoader(props.btnId);
  //       })
  //       .catch((error) => {
  //         if (error?.response?.status === 401) {
  //           WebService.logout();
  //         }
  //         WebService.removeLoader(props.btnId);
  //         props.isShowError
  //           ? reject(error)
  //           : reject(WebService.errorHandler(error));
  //       });

  //   });
  // },
  
  postAPI(props: PropData) {
  return new Promise((resolve, reject) => {
    var bodyFormData = new FormData();

    const body = props.body;

    // ✅ ADD TIMESTAMP HERE (for JSON case)
    if (!props.isFormData && typeof body === "object") {
      body.timestamp = Date.now(); // or new Date().toISOString()
    }

    if (props.isFormData && Array.isArray(body)) {
      body.forEach((el: any, i: number) => {
        if (props.isOutletDocument) {
          bodyFormData.append(`documents[${i}]title`, el.title || '');
          bodyFormData.append(`documents[${i}]code`, el.code || '');
          bodyFormData.append(`documents[${i}]having_document_no`, String(el.having_document_no));
          bodyFormData.append(`documents[${i}]document_number`, el.document_number || '');
          bodyFormData.append(`documents[${i}]has_owner_name`, String(el.has_owner_name || false));
          bodyFormData.append(`documents[${i}]legal_owner_name`, el.legal_owner_name || '');

          if (el.file instanceof File) {
            bodyFormData.append(`documents[${i}]file`, el.file);
          }
        } else {
          bodyFormData.append(`${props?.key}[${i}]`, el);
        }
      });

      // ✅ ADD TIMESTAMP FOR FORM DATA (ARRAY CASE)
      bodyFormData.append("timestamp", Date.now().toString());

    } else {
      for (let key in props.body) {
        const d = props.body[key];
        bodyFormData.append(key, d);
      }

      // ✅ ADD TIMESTAMP FOR FORM DATA (OBJECT CASE)
      if (props.isFormData) {
        bodyFormData.append("timestamp", Date.now().toString());
      }
    }

    const headers = {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      appid: localStorage.getItem("app_id"),
    };

    WebService.addLoader(props.btnId);

    axios.post(
      `${BASE_URL}${props.action}`,
      props.isFormData ? bodyFormData : props.body,
      { headers }
    )
      .then((response) => {
        resolve(response.data);
        toast.success(response?.data?.message);
        WebService.removeLoader(props.btnId);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          WebService.logout();
        }
        WebService.removeLoader(props.btnId);
        props.isShowError
          ? reject(error)
          : reject(WebService.errorHandler(error));
      });

  });
},
  uploadAPI(props: PropData) {
    let formData = new FormData();
    if (props._file && props.key) {
      formData.append(props.key, props._file);
    }
    return new Promise((resolve, reject) => {
      for (let key in props.body) {
        formData.append(key, props.body[key]);
      }
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };

      axios
        .post(`${BASE_URL}${props.action}`, formData, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(WebService.errorHandler(error))
            : reject(error);
        });
    });
  },

  putAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
        xapikey: localStorage.getItem("p_user_id"),
      };

      axios
        .put(`${BASE_URL}${props.action}`, props.body, { headers })
        .then((response) => {
          resolve(response.data)
          toast.success(response.data.message);
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(WebService.errorHandler(error))
            : reject(error);
        });
    });
  },

  beforeLoginAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      WebService.addLoader(props.btnId);
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers }
        )
        .then((response) => {
          resolve(response.data)
          toast.success(response.data.message);
          WebService.removeLoader(props.btnId);
        })
        .catch((error) => {
          WebService.removeLoader(props.btnId);
          if (props.isShowError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        });
    });
  },
  beforeLoginPutAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
      };
      WebService.addLoader(props.btnId);
      axios
        .put(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          { headers }
        )
        .then((response) => {
          resolve(response.data)
          toast.success(response.data.message);
          WebService.removeLoader(props.btnId);
        })
        .catch((error) => {
          WebService.removeLoader(props.btnId);
          if (props.isShowError) {
            reject(WebService.errorHandler(error));
          } else {
            toast.error(error?.response?.data?.message);
            reject(error);
          }
        });
    });
  },
  getAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      const queryParams = {
        // ...props.params, // custom params from caller
        timestamp: Date.now(), // default param
      };
      axios
        .get(`${BASE_URL}${props.action}`, { headers, params: queryParams, })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(error)
            : reject(WebService.errorHandler(error))
        });
    });
  },

  deleteAPI(props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        appid: localStorage.getItem("app_id"),
      };
      axios.delete(`${BASE_URL}${props.action}`, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => {
          if (error?.response?.status === 401) {
            WebService.logout();
          }
          props.isShowError
            ? reject(WebService.errorHandler(error))
            : reject(error);
        });
    });
  },

  errorHandler(error: any) {
    if (error?.response) {
      error = error.response;
    }
    let errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized";
      WebService.logout();
    } else if (error.status === 500) {
      errorMessage =
        error?.data?.ErrorDetails?.message ||
        "An unknown exception has occurred. Please contact administrator";
    } else {
      errorMessage = error.data?.message || "Something went wrong";
    }
    toast.error(errorMessage);
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      const button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = true;
        const loader = document.createElement("span");
        loader.className = "loader";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      const button = document.getElementById(id) as HTMLButtonElement | null;
      if (button) {
        button.disabled = false;
        if (button.firstChild) {
          button.removeChild(button.firstChild);
        }
      }
    }
  },

  logout() {
    localStorage.clear();
    window.location.href = "/login";
  },
};

export default WebService;
